/**
 * 模块名称: 绩效目标与结果
 * @author yangzhihang@372163.com
 */
import React, { useState, useEffect, useRef } from 'react'
import api from 'api'
import {
  Table,
  Form,
  Drawer,
  DatePicker,
  Input,
  InputNumber,
  Button,
  Alert,
  message,
  Switch,
  Select,
  Modal,
  Tooltip,
} from 'antd'
import Auth from '@/components/AuthMiddleware'
import { parseSearch, getExport, allTrim, filterParams, cryptoParamsIntoUrl } from '@/utils'
import EditResult from './module/EditResult'
import Import from '@/components/Import'
import ImportResult from './module/ImportResult'
import { Link } from 'react-router-dom'

const { Column } = Table
const FormItem = Form.Item
const Option = Select.Option
const { RangePicker } = DatePicker
const dateFormat = 'YYYY-MM'

let pageSize = 10
let currentPage = 1
let searchParams = {
  limit: pageSize, 
  page: currentPage
}
let isExclude = false
let expandAll = false

const auditStatusList = [{
    key: 'notyet',
    name: '尚未审核',
  }, {
    key: 'pending',
    name: '审核中',
  }, {
    key: 'success',
    name: '审核成功'
  }, {
    key: 'fail',
    name: '审核失败'
  }
]

const AchResult = props => {

  const { getFieldDecorator, validateFields, resetFields, setFieldsValue, getFieldsValue } = props.form
  const { history, match, location } = props
  const search = parseSearch(location.search)

  const [count, setCount] = useState(0)
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const [editVisible, setEditVisible] = useState(false)
  const [editData, setEditData] = useState({})
  const [authList, setAuthList] = useState([])//按钮权限
  const [checked, setChecked] = useState(0)
  const [checkedIdArr, setCheckedIdArr] = useState([])
  const [assessList, setAssessList] = useState([])
  const [departLeadList, setDepartLeadList] = useState([])
  const [departList, setDepartList] = useState([])
  const [groupList, setGroupList] = useState([])
  const [leadList, setLeadList] = useState([])
  const [isopen, setIsopen] = useState(false)
  const [visibleFile, setVisibleFile] = useState(false)
  const [visibleResult, setVisibleResult] = useState(false)
  const [importType, setImportType] = useState(1)
  const [monthList, setMonthList] = useState([])
  const [excludeIdArr, setExcludeIdArr] = useState([])
  const [expandIdArr, setExpandIdArr] = useState([])
  const [ruleVisible, setRuleVisible] = useState(false)
  const [copyVisible, setCopyVisible] = useState(false)
  const [copyVerifyText, setCopyVerifyText] = useState('')
  const [auditType, setAuditType] = useState(1)
  const ImportRef = useRef()
  const ImportResultRef = useRef()

  useEffect(() => {
    currentPage = search.page ? +search.page : 1
    pageSize = search.limit ? +search.limit : 10
    resetParams()
    getList()
    getPageAuth()
    getSearchData()
  }, [])
  //按钮权限
  const getPageAuth = () => {
    api.getPageAuth().then(list => {
      setAuthList(list)
    })
  }

  const resetParams = () => {
    searchParams = {
      limit: pageSize, 
      page: currentPage
    }
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
    }
  }

  //获取列表
  const getList = () => {
    setLoading(true)
    api.getAchResultList(searchParams).then(res => {
      const { list, count } = res
      setList(list)
      setCount(count)
      if (isExclude) {
        const arr = list.filter(item => !excludeIdArr.includes(item.id))
        setCheckedIdArr(arr.map(item => item.id))
      }
      if (expandAll) {
        setExpandIdArr(list.map(item => item.id))
      } else {
        setExpandIdArr([])
      }
      setLoading(false)
    }).catch(() => { setLoading(false) })
  }

  //重置
  const onReset = () => {
    resetFields()
    handleClear()
    expandAll = false
    setExpandIdArr([])
    currentPage = 1
    resetParams()
    getList()
  }

  //提交
  const formSubmit = evt => {
    evt.preventDefault()
    currentPage = 1
    resetParams()
    setFieldsValue(allTrim(getFieldsValue()))
    validateFields((err, vals) => {
      if (!err) {
        vals = filterParams(vals)
        if (vals.month && vals.month.length === 2) {
          vals.startMonth = vals.month[0].format(dateFormat)
          vals.endMonth = vals.month[1].format(dateFormat)
        }
        delete vals.month
        searchParams = {...searchParams, ...vals}
        getList()
      }
    })
  }
  //点击分页
  const onChangeTable = (pagination, filters, sorter) => {
    searchParams.page = currentPage = pagination.current
    searchParams.limit = pageSize = pagination.pageSize
    history.replace(match.path + '?page=' + currentPage + '&limit=' + pageSize)
    getList()
  }

  // 编辑
  const onEdit = (data, type) => {
    setEditData(data)
    setAuditType(type)
    setEditVisible(true)
  }

  const onDelete = () => {
    if (!isExclude && checkedIdArr.length === 0) {
      message.warning('请先勾选要处理条目')
      return
    }
    let params = JSON.parse(JSON.stringify(searchParams))
    delete params.limit
    delete params.page
    if (isExclude) {
      params.delId = excludeIdArr
    } else {
      params.id = checkedIdArr
    }
    Modal.confirm({
      content: '请确认是否删除？',
      onOk() {
        api.delAchResult(params).then(() => {
          message.success('删除成功')
          onReset()
        })
      }
    })
  }

  const handleApplyAudit = type => {
    if (!isExclude && checkedIdArr.length === 0) {
      message.warning('请先勾选要处理条目')
      return
    }
    let params = JSON.parse(JSON.stringify(searchParams))
    delete params.limit
    delete params.page
    if (isExclude) {
      params.delId = excludeIdArr
    } else {
      params.id = checkedIdArr
    }
    params.auditType = type
    Modal.confirm({
      content: '请确认是否提交审批？',
      onOk() {
        api.applyApprovalTarget(params).then(() => {
          message.success('提交成功')
          onReset()
        })
      }
    })
  }

  const rowSelection = {
    onSelect: (record, selected) => {
      if (selected) {
        checkedIdArr.push(record.id)
        if (isExclude) {
          excludeIdArr.splice(excludeIdArr.indexOf(record.id), 1)
        }
      } else {
        checkedIdArr.splice(checkedIdArr.indexOf(record.id), 1)
        if (isExclude) {
          excludeIdArr.push(record.id)
        }
      }
      updateSelected(checkedIdArr, excludeIdArr)
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      if (selected) {
        changeRows.map(item => checkedIdArr.push(item.id))
        if (isExclude) {
          changeRows.map(item => excludeIdArr.splice(excludeIdArr.indexOf(item.id), 1))
        }
      } else {
        changeRows.map(item => checkedIdArr.splice(checkedIdArr.indexOf(item.id), 1))
        if (isExclude) {
          changeRows.map(item => excludeIdArr.push(item.id))
        }
      }
      updateSelected(checkedIdArr, excludeIdArr)
    },
    selectedRowKeys: checkedIdArr
  }

  const updateSelected = (checkedIdArr, excludeIdArr) => {
    setCheckedIdArr(checkedIdArr)
    setExcludeIdArr(excludeIdArr)
    if (isExclude) {
      setChecked(count - excludeIdArr.length)
    } else {
      setChecked(checkedIdArr.length)
    }
  }

  //改变标记
  const onChangeSign = (record, val) => {
    api.signAchResult({
      staffId: record.staffId,
      month: record.month,
      sign: val ? 1 : 0
    }).then(() => {
      getList()
    })
  }

  //获取检索所需数据
  const getSearchData =  () => {
    api.getSearchData().then(res => {
      const { assessItemsList, leadList, groupList, departList, departLeadList } = res
      setAssessList(assessItemsList)
      setDepartLeadList(departLeadList)
      setDepartList(departList)
      setGroupList(groupList)
      setLeadList(leadList)
    })
  }
  // 获取有数据的月份列表
  const getMonthList =  () => {
    api.getMonthList().then(res => {
      setMonthList(res)
    })
  }

  // 弹出日历和关闭日历的回调
  const handleOpenChange = status => setIsopen(status)
  // 拿到value并进行处理
  const handlePanelChange = value => {
    setIsopen(false)
    setFieldsValue({ month: value })
  }

  // 导出
  const exportFile = type => {
    let params = JSON.parse(JSON.stringify(searchParams))
    delete params.limit
    delete params.page
    params.type = type
    if (isExclude) {
      params.delId = excludeIdArr
    } else {
      params.id = checkedIdArr
    }
    getExport('/fortune/achievements/exportAchResult', params)
  }

  //导入
  const onImportFile = (type) => {
    setImportType(type)
    if (type === 1) {
      setVisibleFile(true)
      ImportRef.current.onRemoved()
    } else {
      getMonthList()
      setVisibleResult(true)
      ImportResultRef.current.onRemoved()
    }
  }

  const onCloseImport = () => {
    setVisibleFile(false)
    setVisibleResult(false)
  }

  const doImport = (fileList, month) => {
    if (fileList.length > 0) {
      if (fileList[0].status !== "removed") {
        const { full, name, url } = fileList[0]
        const params = {
          type: importType,
          fullPath: full,
          fileName: name,
          relativePath: url,
        }
        if (importType === 2) {
          params.month = month
        }
        api.uploadAchResultFile(params, false, true).then(result => {
          if (result.msg) {
            Modal.confirm({
              title: '提示',
              content: result.msg,
            })
          } else {
            message.success('导入成功')
          }
          if (importType === 1) {
            ImportRef.current.onLoading()
            setVisibleFile(false)
          } else {
            ImportResultRef.current.onLoading()
            setVisibleResult(false)
          }
          getList()
        }).catch(() => {
          if (importType === 1) {
            ImportRef.current.onLoading()
          } else {
            ImportResultRef.current.onLoading()
          }
        })
      } else {
        message.error('请导入模板')
      }
    } else {
      message.error('请导入模板')
    }
  }

  const expandedRowRender = record => {
    return (
      <Table
        size="small"
        dataSource={record.targetList}
        rowKey="id"
        pagination={false}
      >
        <Column 
          title="考核项" 
          dataIndex="assessItems" 
          width={'20%'} 
          render={(text, record) => (
            <Tooltip title={record.assessItemDesc}>
              <span dangerouslySetInnerHTML={{ __html: text }}></span>
            </Tooltip>
          )}
        />
        <Column 
          title="考核权重" 
          dataIndex="weight" 
          width={'20%'} 
          render={(text, record) => (
            <span dangerouslySetInnerHTML={{ __html: text }}></span>
          )}
        />
        <Column 
          title="考核目标" 
          dataIndex="target" 
          width={'20%'} 
          render={(text, record) => (
            <span dangerouslySetInnerHTML={{ __html: text }}></span>
          )}
        />
        <Column 
          title="完成结果" 
          dataIndex="result" 
          width={'20%'} 
          render={text => (
            <>
              {text === 0 ? '-' : text}
            </>
          )} 
        />
        <Column 
          title="完成率" 
          dataIndex="completionRate" 
          width={'20%'} 
          render={text => (
            <>
              {text === '0%' ? '-%' : text}
            </>
          )} 
        />
      </Table>
    )
  }

  const handleClear = () => {
    isExclude = false
    setCheckedIdArr([])
    setExcludeIdArr([])
    setChecked(0)
  }

  const handleCheckedAll = () => {
    isExclude = true
    setCheckedIdArr(list.map(item => item.id))
    setExcludeIdArr([])
    setChecked(count)
  }

  const handleCheckedReverse = () => {
    const status = !isExclude
    isExclude = status
    if (status) {
      setChecked(count - checkedIdArr.length)
    } else {
      setChecked(excludeIdArr.length)
    }
    if (status) {
      const arr = list.filter(item => !checkedIdArr.includes(item.id))
      setCheckedIdArr(arr.map(item => item.id))
      setExcludeIdArr(checkedIdArr)
    } else {
      setCheckedIdArr(excludeIdArr)
      setExcludeIdArr([])
    }
  }

  const onExpandedRowsChange = expandedRows => {
    setExpandIdArr(expandedRows)
  }

  const handleExpandAll = () => {
    if (expandIdArr.length > 0) {
      expandAll = false
      setExpandIdArr([])
    } else {
      expandAll = true
      setExpandIdArr(list.map(item => item.id))
    }
  }

  const showCopyModal = () => {
    api.copyAchTargetVerify().then(data => {
      setCopyVerifyText(data)
      setCopyVisible(true)
    })
  }

  const handleCopyTarget = () => {
    setCopyVisible(false)
    setLoading(true)
    api.copyAchTarget().then(() => {
      message.success('复制完成')
      setLoading(false)
    }).catch(() => { setLoading(false) })
  }

  const handlePreview = id => {
    api.getHost().then((res) => {
      window.open(`${res.url}/api/fortune/achievements/Preview?id=${id}`, '_blank')
    })
  }

  return <>
    <div className="search-doc-wrap">
      <Form onSubmit={formSubmit} {...formItemLayout}>
        <div className="form-box">
          <FormItem label="姓名">
            {getFieldDecorator('staffName')(<Input placeholder="请输入姓名" />)}
          </FormItem>
          <FormItem label="员工号">
            {getFieldDecorator('staffNo')(<InputNumber placeholder="请输入员工号" style={{ width: '100%'}} />)}
          </FormItem>
          <FormItem label="部门负责人">
            {getFieldDecorator('departLeadId')(<Select 
              placeholder="请选择"
              showSearch
              allowClear
              filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
              {
                departLeadList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
              }
            </Select>)}
          </FormItem>
          <FormItem label="绩效月份">
            {getFieldDecorator('month')(<RangePicker
              open={isopen}
              placeholder={['开始月份', '结束月份']}
              format={dateFormat}
              mode={['month', 'month']}
              onOpenChange={handleOpenChange}
              onPanelChange={handlePanelChange}
            />)}
          </FormItem>
          <FormItem label="所属事业群">
            {getFieldDecorator('groupId')(<Select 
              placeholder="请选择"
              showSearch
              allowClear
              filterOption={(input, option) => option.props.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
              {
                groupList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
              }
            </Select>)}
          </FormItem>
          <FormItem label="所属部门">
            {getFieldDecorator('departmentId')(<Select 
              placeholder="请选择"
              showSearch
              allowClear
              filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
              {
                departList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
              }
            </Select>)}
          </FormItem>
          <FormItem label="直接主管">
            {getFieldDecorator('leaderId')(<Select 
              placeholder="请选择"
              showSearch
              allowClear
              filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
              {
                leadList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
              }
            </Select>)}
          </FormItem>
          <FormItem label="考核项">
            {getFieldDecorator('assessItems')(<Select 
              placeholder="请选择"
              showSearch
              allowClear
              filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
              {
                assessList.map((item, index) => <Option key={index} value={item}>{item}</Option>)
              }
            </Select>)}
          </FormItem>
        </div>
        <FormItem className="btns" label=" " colon={false}>
          <Button type="primary" htmlType="submit">查询</Button>
          <Button onClick={onReset}>重置</Button>
        </FormItem>
      </Form>
    </div>
    <div className="line"></div>
    <div>
      <div className="ach-top-btn-super">
        <div>
          <Button type="primary" onClick={() => setRuleVisible(true)}>绩效管理规则</Button>
          <Auth auths={authList} code="copy">
            <Button type="primary" onClick={showCopyModal} style={{ marginLeft: 15 }}>复制目标</Button>
          </Auth>
        </div>
        <div>
          <Auth auths={authList} code="delete">
            <Button type="primary" icon="delete" onClick={onDelete}>批量删除</Button>
          </Auth>
          <Auth auths={authList} code="export-result">
            <Button type="primary" icon="upload" onClick={() => exportFile(2)} style={{ marginLeft: 15 }}>导出绩效结果</Button>
          </Auth>
          <Auth auths={authList} code="export-target">
            <Button type="primary" icon="upload" onClick={() => exportFile(1)} style={{ marginLeft: 15 }}>导出绩效详情</Button>
          </Auth>
          <Auth auths={authList} code="import-target">
            <Button type="primary" icon="download" onClick={() => onImportFile(1)} style={{ marginLeft: 15 }}>导入目标</Button>
          </Auth>
          <Auth auths={authList} code="import-result">
            <Button type="primary" icon="download" onClick={() => onImportFile(2)} style={{ marginLeft: 15 }}>导入结果</Button>
          </Auth>
        </div>
      </div>
      <Alert className="corp-count" message={
        <>
          <span>已选择 <span style={{ color: '#168FFF' }}>{checked}</span> 项</span>
          <span style={{ marginLeft: 20 }}>总共{count}条数据</span>
          <span style={{ marginLeft: 20, color: '#168FFF', cursor: 'pointer' }} onClick={handleClear}>清空</span>
          <span style={{ marginLeft: 20, color: '#168FFF', cursor: 'pointer' }} onClick={handleCheckedAll}>全选</span>
          <span style={{ marginLeft: 20, color: '#168FFF', cursor: 'pointer' }} onClick={handleCheckedReverse}>反选</span>
          <span style={{ marginLeft: 20, color: '#168FFF', cursor: 'pointer' }} onClick={handleExpandAll}>全部展开/收起</span>
        </>
      } type="info" showIcon />
      <Table
        size="small"
        dataSource={list}
        rowKey="id"  
        loading={loading}
        pagination={{
          pageSize,
          total: count,
          current: currentPage,
          showQuickJumper: true,
          showSizeChanger: true,
          pageSizeOptions: ['10', '50', '100', '500', '1000', '2000']
        }}
        onChange={onChangeTable}
        rowSelection={rowSelection}
        expandedRowRender={expandedRowRender}
        onExpandedRowsChange={onExpandedRowsChange}
        expandedRowKeys={expandIdArr}
      >
        <Column title="绩效月份" dataIndex="month" />
        <Column title="姓名" dataIndex="staffName" />
        <Column title="员工号" dataIndex="staffNo" />
        <Column title="职位" dataIndex="jobPosition" />     
        <Column title="直接主管" dataIndex="leaderName" />
        <Column title="部门负责人" dataIndex="depleadName" />
        <Column title="所属事业群" dataIndex="groupName" />
        <Column title="所属部门" dataIndex="departmentName" />
        <Column title="部门类型" dataIndex="departmentType" />
        <Column 
          title="工作绩效结果" 
          dataIndex="assessResult" 
          render={text => (
            <>
              {text === '0.00%' ? '-%' : text}
            </>
          )} 
        />
        <Column 
          title="最终绩效结果" 
          dataIndex="finnalResult"
          render={text => (
            <>
              {text === '0.00%' ? '-%' : text}
            </>
          )} 
        />
        <Column 
          title="标记" 
          dataIndex="sign" 
          render={(text, record) => <Switch size="small" checked={text === 1} onChange={val => onChangeSign(record, val)} />} 
        />
        <Column 
          title="审核状态" 
          className="ach-audit-status"
          render={record => (
            <>
              {record.targetAuditStatus !== 0 && (
                <div className={auditStatusList[record.targetAuditStatus]?.key}>
                  绩效目标{auditStatusList[record.targetAuditStatus]?.name}
                </div>
              )}
              {record.resultAuditStatus !== 0 && (
                <div className={auditStatusList[record.resultAuditStatus]?.key}>
                  绩效结果{auditStatusList[record.resultAuditStatus]?.name}
                </div>
              )}
            </>
          )} 
        />
        <Column 
          title="操作"
          align="center"
          render={record => (
            <>
              {record.targetAuditStatus !== 0 && (
                <div>
                  <Link to={cryptoParamsIntoUrl('/ach/achaudit/detail', { id: record.id, auditType: 1 })}>
                    绩效目标审批详情
                  </Link>
                </div>
              )}
              {record.resultAuditStatus !== 0 && (
                <div>
                  <Link to={cryptoParamsIntoUrl('/ach/achaudit/detail', { id: record.id, auditType: 2 })}>
                    绩效结果审批详情
                  </Link>
                </div>
              )}
              {[0, 3].includes(record.targetAuditStatus) && (
                <div>
                  <Auth auths={authList} code="edit">
                    <a onClick={() => onEdit(record, 1)}>绩效目标修改</a>
                  </Auth>
                </div>
              )}
              {(record.targetAuditStatus === 2 && [0, 3].includes(record.resultAuditStatus)) && (
                <div>
                  <Auth auths={authList} code="edit">
                    <a onClick={() => onEdit(record, 2)}>绩效结果修改</a>
                  </Auth>
                </div>
              )}
              {(record.targetAuditStatus === 2 || record.resultAuditStatus === 2) && (
                <div>
                  <a onClick={() => handlePreview(record.id)}>打印预览</a>
                </div>
              )}
            </>
          )}
        />
      </Table>
      <div className="ach-bottom-btn-super">
        <Button type="primary" onClick={() => handleApplyAudit(1)}>发起绩效目标审批</Button>
        <Button type="primary" onClick={() => handleApplyAudit(2)} style={{ marginLeft: 15 }}>发起绩效结果审批</Button>
      </div>
    </div>
    <Drawer
      title="编辑"
      width={600}
      onClose={() => setEditVisible(false)}
      visible={editVisible}
      destroyOnClose={true}
    >
      <EditResult 
        data={editData} 
        auditType={auditType}
        setVisible={setEditVisible} 
        getList={getList}
      />
    </Drawer>
    <Import
      title="导入目标数据"
      onSearch={doImport}
      visibleFile={visibleFile}
      onCloseImport={onCloseImport}
      ImportTemplate="/api/fortune/achievements/exportTargetTmp"
      ImportRef={ImportRef}
      accept=".xls, .xlsx"
    />
    <ImportResult
      title="导入结果数据"
      importFn={doImport}
      visibleFile={visibleResult}
      onCloseImport={onCloseImport}
      ImportRef={ImportResultRef}
      monthList={monthList}
    />
    <Modal
      title="绩效管理规则"
      visible={ruleVisible}
      onCancel={() => setRuleVisible(false)}
      footer={null}
      width={1100}
      className="ach-modal-super"
    >
      <div className="rule-list">
        <div className="rule-item">
          <div className="title">1、绩效提交时间：</div>
          <div className="issue">(1)绩效目标的上传、修改、审批的开放时间：每月25日（含）开始三个工作日内；</div>
          <div className="issue">(2)绩效结果的上传、修改、审批的开放时间：每月第三个工作日到第八个工作日；</div>
        </div>
        <div className="rule-item">
          <div className="title">2、绩效数据修改：</div>
          <div className="issue">(1)审核中和审核通过的绩效目标和绩效结果不允许修改；</div>
          <div className="issue">(2)部分考核项的绩效目标和绩效结果由内控部或绩效部制定，涉及这部分考核项的员工的绩效目标或绩效结果由内控部导入或修改后，其他部门的人员不可再导入或修改；</div>
        </div>
        <div className="rule-item">
          <div className="title">3、绩效目标复制：</div>
          <div className="issue">可复制用户权限内的满足条件的员工本月的绩效目标到下月的绩效目标，对已存在的数据覆盖，不满足条件的包括内控人员导入或修改的、审批中、审批通过绩效目标；</div>
        </div>
        <div className="rule-item">
          <div className="title">4、发起绩效目标审批时，需满足的条件：</div>
          <div className="issue">(1)所有被选中的员工的绩效目标不处于“绩效目标审批中”、“绩效目标审批通过”的状态；</div>
          <div className="issue">(2)所有选中的员工的绩效月份必须相同；</div>
          <div className="issue">(3)所有选中的员工的审批流程中的审批节点和审批人相同；</div>
          <div className="issue">(4)所有选中的员工各自的绩效目标权重和为100%；</div>
        </div>
        <div className="rule-item">
          <div className="title">5、绩效结果：</div>
          <div className="issue">只有员工某月的绩效目标通过审核后，才允许导入或修改该员工该月的绩效结果；</div>
        </div>
        <div className="rule-item">
          <div className="title">6、发起绩效结果审批时，需满足以下条件：</div>
          <div className="issue">(1)所有被选中的员工的任意一项绩效结果都不为空；</div>
          <div className="issue">(2)所有被选中的员工的绩效结果不处于“绩效结果审批中”、“绩效结果审批通过”的状态中；</div>
          <div className="issue">(3)所有选中的员工的绩效月份必须相同；</div>
          <div className="issue">(4)所有选中的员工的审批流程中的审批节点和审批人相同；</div>
        </div>
        <div className="rule-item">
          <div className="title">7、最终绩效：</div>
          <div className="issue">最终绩效结果=工作绩效结果*出勤率；</div>
        </div>
        <div className="rule-item">
          <div className="title">8、其他疑问：</div>
          <div className="issue">请联系绩效部咨询。</div>
        </div>
      </div>
    </Modal>
    <Modal
      title="提示"
      visible={copyVisible}
      onCancel={() => setCopyVisible(false)}
      onOk={handleCopyTarget}
      width={800}
      className="ach-modal-super"
    >
      <div dangerouslySetInnerHTML={{ __html: copyVerifyText }} />
      <div className="tip-text">请确定是否继续？</div>
    </Modal>
  </>
}

export default Form.create()(AchResult)
